"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Game = void 0;
var Game;
(function (Game) {
    Game["FiveCardDraw"] = "FIVE_CARD_DRAW";
    Game["FiveCardStud"] = "FIVE_CARD_STUD";
    Game["SevenCardStud"] = "SEVEN_CARD_STUD";
    Game["TexasHoldem"] = "TEXAS_HOLDEM";
    Game["FollowTheQueen"] = "FOLLOW_THE_QUEEN";
    Game["LowChicago"] = "LOW_CHICAGO";
    Game["HighChicago"] = "HIGH_CHICAGO";
    Game["RollYourOwn"] = "ROLL_YOUR_OWN";
    Game["IronCross"] = "IRON_CROSS";
    Game["HollywoodSquares"] = "HOLLYWOOD_SQUARES";
    Game["TheSlut"] = "THE_SLUT";
    Game["Omaha"] = "OMAHA";
    Game["SevenTwentySeven"] = "SEVEN_TWENTY_SEVEN";
    Game["Texas"] = "TEXAS";
    Game["PassTheTrash"] = "PASS_THE_TRASH";
    Game["Guts"] = "GUTS";
})(Game || (exports.Game = Game = {}));
//# sourceMappingURL=GameInterface.js.map